import GeneralHelper from '../../00_utilities/helpers/GeneralHelper';

class ArrowDown {
    constructor(elem) {
        this.elem = elem;
    }

    init() {
        this.addSmoothScroll();

        window.addEventListener('resize', GeneralHelper.throttle(() => {
            this.addSmoothScroll();
        }, 400));
    }

    addSmoothScroll() {
        const clickListener = this.elem;
        const targetElementToScroll = this.elem.closest('.component-container');
        let targetElementToScrollHeight = targetElementToScroll.clientHeight;

        clickListener.addEventListener('click', () => {
            window.scrollTo(0, targetElementToScrollHeight);
        });
    }
}

export default ArrowDown;
